app.controller('teacherSignupCtrl', [
    '$state', function ($state) {
    	var vm = this;

    	vm.next = function() {
    		$state.go('teacher.setupexercises');
    	}
    }
]);